import type { ComponentProps } from "react";
import { Dropdown } from "../Dropdown/Dropdown";
import { AutocompleteList } from "../AutocompleteList/AutocompleteList";
import type { AutocompletePlace } from "../../api/v1.6/autocomplete";

const MAX_RESULTS = 5;

type Props = {
  results: AutocompletePlace[];
  onSelectPlace: (place: AutocompletePlace) => void;
  className?: string;
  ariaControlsID?: string;
} & Omit<ComponentProps<typeof Dropdown>, "results">;

export function AutocompleteDropdown({
  ariaControlsID = "search-controls",
  results,
  onSelectPlace,
  className,
  ...props
}: Props) {
  const truncatedResults = results.slice(0, MAX_RESULTS);

  return (
    <Dropdown
      className={className}
      id={ariaControlsID}
      role="listbox"
      {...props}
    >
      <AutocompleteList
        results={truncatedResults}
        isInputFocused={true}
        onSelectPlace={onSelectPlace}
      />
    </Dropdown>
  );
}
